import { Avatar } from 'avatar-components';
import { useGetIsUngated } from '../../hooks/useGetIsUngated';
import { GATES } from '../../constants/auth';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalUserAvatar = ({
  approvalUser
}) => {
  const {
    email
  } = approvalUser;
  const getHasGate = useGetIsUngated();
  const hasApprovalDueDateGate = getHasGate(GATES.APPROVAL_DUE_DATE);
  return /*#__PURE__*/_jsx(Avatar, {
    "data-test-id": "approval-user-avatar",
    size: hasApprovalDueDateGate ? 'sm' : 'md',
    hubSpotUserEmail: email,
    displayName: email
  });
};